import styled from 'styled-components';
import { palette } from 'styled-tools';

import { IconButton, minWidth } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Grid = styled(GridWrapper)`
	padding-top: 8px;
	position: relative;

	${minWidth('tablet')} {
		grid-template-columns: 1fr 2fr 2fr 1fr;
		padding-top: 48px;
	}
`;

export const Wrapper = styled.div<{ isVisible: boolean }>`
	align-items: center;
	display: flex;
	flex-direction: column;
	height: 100%;
	grid-column-end: 4;
	grid-column-start: 1;
	text-align: center;
	width: 100%;

	${minWidth('tablet')} {
		grid-column-start: 2;
	}
`;

export const BackButton = styled(IconButton)<{ $rotate?: boolean }>`
	cursor: pointer;
	height: 24px;
	left: 0;
	position: absolute;
	top: 0;
	transform: ${p => (p.$rotate ? 'rotate(0deg)' : 'rotate(-90deg)')};
	width: 24px;

	& path {
		fill: ${palette('white')};
	}

	${minWidth('tablet')} {
		height: 32px;
		width: 32px;
	}
`;
